/*
  keep track of actions that we want to put a delay on when called from move events
  and tell us when its time to do that action
*/
class DelayHandler {
  constructor() {
    this.activeDelays = {};
  }

  clearDelayFor(action) {
    const d = this.activeDelays[action];
    if (!d) return;
    if (d.timeout) {
      clearTimeout(d.timeout);
    }
    delete this.activeDelays[action];
  }

  isDelayed(action,id) {
    if (!this.activeDelays[action]) return false;
    if (this.activeDelays[action].initiatedId == id) return true;
    return false;
  }

  isTriggered(action,id) {
    if (!this.activeDelays[action]) return false;
    if (this.activeDelays[action].triggeredId == id) return true;
    return false;
  }

  _trigger(action,id) {
    this.activeDelays[action].initiatedId = null;
    this.activeDelays[action].triggeredId = id;
  }

  /*
    start delaying a certain action
    when the timeout fires, its ok to run that action
  */
  initializeDelay({action,id,delay,callback}) {
    this.clearDelayFor(action);

    const timeout = setTimeout(() => {
      this._trigger(action,id);
      if (callback) {
        callback();
      }
    },delay);

    this.activeDelays[action] = {
      initiatedId: id,
      triggeredId: null,
      timeout,
    };
  }
}

const delayHandler = new DelayHandler();

export { DelayHandler, delayHandler };



// WEBPACK FOOTER //
// ./starling/src/lib/delay-handler.js